import e from"react";import{S as r}from"../../index-1a0e5951.js";const t=({load:t,render:a})=>e.createElement(e.Fragment,null,t?e.createElement(r,null):a());export{t as default};
